import React, { useState } from 'react';

import {
    Grid,
    Button,
    Dialog,
    DialogContent,
    useTheme,
    useMediaQuery
} from "@material-ui/core";
import DynamicInput from '../InputComponents/DynamicInput';
import services from '../../Services';
import moment from 'moment';

const {hr} = services;

const RehireModal = ({ RehireData }) => {

    const [updateRehireModal, setUpdateRehireModal] = useState()

    let { open, close, mainFlag, setMainFlag, employeeDetails } = RehireData;
    const theme = useTheme();

    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    let fields = [
        { type: 2, name: "Effective Date", initial: updateRehireModal,defaultDate: null, onChange: (value) => setUpdateRehireModal(value) },

    ]


    function onUpdateRehireModal(e) {
        e.preventDefault()
        let data = {
            id: employeeDetails?.id,
            effective_date: moment(updateRehireModal).format('YYYY-MM-DD')
        }
         

        try {
            hr.onUpdateRehireModal(data).then((certificateData) => {
                setMainFlag(!mainFlag)
                close(false)
            }).catch((err) => {   });
        }
        catch (exc) {
             
        }
    }
    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={() => close(false)}
            className="BroadcastMessageModal LiqTables"
            aria-labelledby="responsive-dialog-title"
        >
            <Button autoFocus onClick={() => close(false)} className="ModalClose">
            </Button>
            <DialogContent style={{ height: '450px' }}>
                <form onSubmit={onUpdateRehireModal}>
                    <h2>Rehire Employee</h2>

                    <DynamicInput fields={fields} />

                    <div className="test" >
                        <Grid xs={12} container justify="center" className="mt30">
                            <Button type="submit" className="LinkButton">Save</Button>
                        </Grid>
                    </div>

                </form>
            </DialogContent>
        </Dialog>
    )
}

export default RehireModal